import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreInvitationRoutingModule} from '@app/features/store-invitation/store-invitation-routing.module';
import {AcceptInvitaionComponent} from './accept-invitaion/accept-invitaion.component';
import {CreateStoreComponent} from './create-store/create-store.component';
import {SharedModule} from "@shared/shared.module";
import {VerifyStoreFormComponent} from './forms/verify-store-form/verify-store-form.component';
import {ReactiveFormsModule} from "@angular/forms";
import {StoreDescriptionFormComponent} from './forms/store-description-form/store-description-form.component';
import {NgbProgressbarModule} from "@ng-bootstrap/ng-bootstrap";
import {StoreDetailsFormComponent} from './forms/store-details-form/store-details-form.component';
import {StoreLocationFormComponent} from './forms/store-location-form/store-location-form.component';
import {AgmCoreModule} from "@agm/core";
import {CreateStoreService} from "@app/features/store-invitation/create-store.service";
import {StoreCreatedComponent} from './store-created/store-created.component';
import {NgxSpinnerModule} from "ngx-spinner";
import { ProviderLoginSetupComponent } from './provider-login-setup/provider-login-setup.component';


@NgModule({
  declarations: [
    AcceptInvitaionComponent,
    CreateStoreComponent,
    VerifyStoreFormComponent,
    StoreDescriptionFormComponent,
    StoreDetailsFormComponent,
    StoreLocationFormComponent,
    StoreCreatedComponent,
    ProviderLoginSetupComponent
  ],
  providers: [CreateStoreService],
  imports: [
    CommonModule,
    StoreInvitationRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    NgbProgressbarModule,
    AgmCoreModule,
    NgxSpinnerModule
  ]
})
export class StoreInvitationModule {
}
